import ChartDataLabels from 'chartjs-plugin-datalabels';

export const pieChartBuilder = (data, chartColors) => {
        // console.log(chartColors);
        var pieChart = [];
        pieChart['options'] = {
            responsive: true,
            maintainAspectRatio: false, // Allow custom sizing
            animation: false,
            plugins: {
                ChartDataLabels,
                legend: {
                    labels: {
                    color: '#f5f5f5',  // Set legend label color if desired 
                    }
                },
                datalabels: {
                    anchor: 'center',         // Positions label at the edge
                    align: 'center  ',          // Aligns label to outer side
                    color: 'black',        // Set label color if desired
                    font: {
                        size: 14           // Adjust font size if needed
                    },
                }
            },

        }
        pieChart['data'] = {
            labels: data.labels,
            datasets:  [
                {
                    label: 'Class Distribution',
                    data: data.data,
                    backgroundColor: data.labels.map((label) => {
                        // console.log(label);
                        // console.log(chartColors[label]);
                        return chartColors[label];
                    })
                }
            ]
        }
        return pieChart;
    }